import { useIntl } from 'react-intl'
import clsx from 'clsx'
import styled from 'styled-components'
import { rem } from 'polished'
import IconButton from 'LuxKit/Button/IconButton'
import LineArrowDownIcon from 'LuxKit/Icons/line/LineArrowDownIcon'
import noop from 'lib/function/noop'

const ButtonWrapper = styled.div`
  position: absolute;
  bottom: calc(100% + ${rem(16)});
  inset-inline-start: 50%;
  transform: translateX(-50%);
  z-index: 10;

  opacity: 0;
  pointer-events: none;

  transition: opacity 0.2s ease;

  &.visible {
    opacity: 1;
    pointer-events: auto;
  }

  [dir='rtl'] & {
    transform: translateX(50%);
  }
`

const StyledIconButton = styled(IconButton)`
  box-shadow: ${props => props.theme.shadow.bottom.small};
`

interface Props {
  visible: boolean
  onClick?: () => void
}

export default function AssistantScrollToBottomButton({ visible, onClick = noop }: Props) {
  const intl = useIntl()

  const scrollToBottomAriaLabel = intl.formatMessage({
    id: 'JtEwYrQXHepi-d_CAscE',
    defaultMessage: 'Scroll to bottom',
    description: 'Accessible label for the scroll to bottom button in the chat panel',
  })

  return (
    <ButtonWrapper className={clsx({ visible })}>
      <StyledIconButton
        kind="secondary"
        variant="dark"
        shape="circle"
        size="large"
        onClick={onClick}
        aria-label={scrollToBottomAriaLabel}
        aria-hidden={!visible}
        tabIndex={visible ? undefined : -1}
        type="button"
      >
        <LineArrowDownIcon />
      </StyledIconButton>
    </ButtonWrapper>
  )
}
